import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=21a387cd&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a387cd')) {
      api.createRecord('21a387cd', component.options)
    } else {
      api.reload('21a387cd', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=21a387cd&", function () {
      api.rerender('21a387cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2beQMth7xDv32/JS/videoIframe.vue"
export default component.exports